// extracted by mini-css-extract-plugin
export var fadeInOut = "_3g-3";
export var icon = "_3g-4";
export var savedIndicator = "_3g-2";
export var savingIndicator = "_3g-0";
export var spin = "_3g-1";